export const TARGET_AUDIENCES = [
  { value: "all", title: "All" },
  // { value: "counsellors", title: "Counsellors" },
  // { value: "psychotherapists", title: "Psychotherapists" },
  // { value: "psychiatrists", title: "Psychiatrists" },
  // { value: "students", title: "Students" },
  { value: "all_therapists", title: "All Therapists" },
  { value: "psychologists", title: "Psychologists" },
  { value: "supervisors", title: "Supervisors" },
  { value: "healthcare_professionals", title: "Other Healthcare Professionals" },
  { value: "life_coaches", title: "Life Coaches" },
  // { value: "general_public", title: "General Public" },
  { value: "psychologist", title: "Psychologist" },
];

export const TARGET_FILE_CONTENT_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  "application/vnd.ms-word.document.macroEnabled.12",
  "application/vnd.ms-word.template.macroEnabled.12"
];
export const TARGET_FILE_MAX_SIZE = 5 * 1024 * 1024;

export const PROVIDER_LOGO_CONTENT_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/png"
];
export const VALIDATION_CONSTRAINST = {
  title: {
    presence: true,
    length: {
      maximum: 50,
      tooLong: "maximum 50 symbols"
    }
  },
  provider_bio: {
    length: {
      maximum: 1000,
      tooLong: "maximum 1000 symbols"
    }
  },
  host: {
    length: {
      maximum: 200,
      tooLong: "maximum 200 symbols"
    }
  },
  contact_email: {
    email: true,
    length: {
      maximum: 200,
      tooLong: "maximum 200 symbols"
    }
  },
  provided_by: {
    presence: true
  },
  how_many_hours: {
    numericality: true
  },
  cost: {
    numericality: true
  }
};

export const MODULE_VALIDATION = {
  title: {
    presence: { message: "Module title must be specified" },
    length: {
      maximum: 200,
      tooLong: "There are only 200 characters allowed"
    }
  },
  details: {
    length: {
      maximum: 50000,
      tooLong: "There are only 50,000 characters allowed"
    },
    presence: { message: "Module description must be specified" }
  }
};

export const QUESTION_CONSTRAINS = {
  text: {
    length: {
      maximum: 20000,
      tooLong: "There are only 20000 characters allowed"
    },
    presence: { message: "Question can't be blank" }
  }
};

export const QUIZ_CONSTRAINS = {
  text: {
    length: {
      maximum: 20000,
      tooLong: "There are only 20000 characters allowed"
    },
    presence: {
      message: "Please ensure all quiz questions are specified for Module "
    }
  }
};

export const COUPONST_CONSTRAINS = {};

export const TARGET_AUDIENCES_MULTISELECT = [
  { value: "0", label: "All" },
  // { value: "1", label: "Counsellors" },
  // { value: "2", label: "Psychotherapists" },
  // { value: "4", label: "Psychiatrists" },
  // { value: "6", label: "Students" },
  { value: "11", label: "All Therapists" },
  { value: "3", label: "Psychologists" },
  { value: "5", label: "Supervisors" },
  { value: "7", label: "Other Healthcare Professionals" },
  { value: "8", label: "Life Coaches" },
  // { value: "10", label: "General Public" }
];

export const TARGET_AUDIENCES_MULTISELECT_VIEW = [
  { value: 0, label: "All" },
  // { value: 1, label: "Counsellors" },
  // { value: 2, label: "Psychotherapists" },
  // { value: 4, label: "Psychiatrists" },
  // { value: 6, label: "Students" },
  { value: 11, label: "All Therapists" },
  { value: 3, label: "Psychologists" },
  { value: 5, label: "Supervisors" },
  { value: 7, label: "Other Healthcare Professionals" },
  { value: 8, label: "Life Coaches" },
  // { value: 10, label: "General Public" }
];



// WEBPACK FOOTER //
// ./src/components/create_organization_workshop/constants.js